import gql from 'graphql-tag';

const GET_ALL_EMPLOYEES = gql`
  query {
    getAllEmployees {
      userId
      firstName
      lastName
      name
      email
      phoneNumber
      contactNumber
      activated
      designation {
        designationId
        name
      }
      businessFunction {
        businessFunctionId
        name
      }
      team {
        teamId
        name
      }
    }
  }
`;

const GET_USER_LIST_META = gql`
  query {
    getCompanyUserListViewMetaInfo
  }
`;

const GET_USER_LIST = gql`
  query(
    $listInfo: ListInfoInput!
    $isITProduct: Boolean!
    $isMSPProduct: Boolean!
  ) {
    getCompanyUsersList(listInfo: $listInfo) {
      userList {
        userId
        firstName
        name
        lastName
        email
        phoneNumber
        contactNumber
        activated
        customFields
        technicianBurnRate
        techRoleType @include(if: $isITProduct)
        roles @include(if: $isMSPProduct) {
          roleId
          name
          roleType {
            type
          }
        }
        reportingManager {
          userId
          name
        }
        associations {
          id
          client {
            accountId
            name
          }
          site {
            id
            name
          }
        }
        activationMailStatus
        activationMailFailureReason
        operationalStatus
        designation {
          designationId
          name
        }
        businessFunction {
          businessFunctionId
          name
        }
        team {
          teamId
          name
        }
      }
      listInfo {
        page
        pageSize
        hasMore
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_ALL_EMPLOYEE_LIST = gql`
  query($input: GetTechnicianListInput!) {
    getTechnicianList(input: $input) {
      userList {
        userId
        firstName
        name
        lastName
        email
        phoneNumber
        contactNumber
        activated
        roles {
          roleId
          name
        }
        activationMailStatus
        activationMailFailureReason
        operationalStatus
      }
      listInfo {
        page
        pageSize
        hasMore
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_COMPANY_USER = gql`
  query($userId: ID!, $isITProduct: Boolean!) {
    getCompanyUser(userId: $userId) {
      userId
      firstName
      lastName
      email
      phoneNumber
      contactNumber
      countryCode
      activated
      technicianBurnRate
      designation {
        designationId
        name
      }
      businessFunction {
        businessFunctionId
        name
      }

      team {
        teamId
        name
      }
      reportingManager {
        userId
        firstName
        lastName
        email
      }
      customFields
      roles {
        roleId
        name
        roleType {
          roleTypeId
          name
          type
        }
      }
      associations @include(if: $isITProduct) {
        id
        site {
          id
          name
        }
      }

      groups {
        groupId
        name
      }
    }
  }
`;

const DELETE_EMPLOYEE = gql`
  mutation($ids: [ID]!, $forget: Boolean) {
    deleteCompanyUsers(ids: $ids, forget: $forget)
  }
`;

const ACTIVATE_EMPLOYEE = gql`
  mutation($userIds: [ID!], $operationalStatus: UserOperationalStatus!) {
    updateTechnicianLicenseState(
      userIds: $userIds
      operationalStatus: $operationalStatus
    )
  }
`;

const GET_ALLMSP_DESIGNATIONS = gql`
  query {
    getDesignationList {
      designationId
      name
    }
  }
`;

const GET_MSP_BUSINESSFUNCTIONS = gql`
  query {
    getBusinessFunctionList {
      businessFunctionId
      name
    }
  }
`;

const GET_MSP_TEAMLIST = gql`
  query {
    getTeamList {
      teamId
      name
    }
  }
`;

const RESEND_EMPLOYEE_ACTIVATION = gql`
  mutation($userId: ID!) {
    resendEmployeeActivationMail(userId: $userId)
  }
`;

export {
  GET_ALL_EMPLOYEES,
  GET_ALLMSP_DESIGNATIONS,
  GET_MSP_BUSINESSFUNCTIONS,
  GET_MSP_TEAMLIST,
  DELETE_EMPLOYEE,
  RESEND_EMPLOYEE_ACTIVATION,
  GET_ALL_EMPLOYEE_LIST,
  ACTIVATE_EMPLOYEE,
  GET_USER_LIST_META,
  GET_USER_LIST,
  GET_COMPANY_USER
};
